import styled, { keyframes } from 'styled-components';

const FadeIn = keyframes`
from{
  opacity: 0;
}
to{
  opacity: 100
}
`;

export const PaginacaoContainer = styled.div`
  animation: ${FadeIn} 1s;
  width: 100%;
  min-height: ${({ tipo }) => (tipo === 'solicitacoes' ? '500px' : 'auto')};

  p {
    color: #4d4d4d;
    font-weight: bold;
  }
`;
